module.exports = __webpack_public_path__ + "media/images/beauty/main_image2@3x-6f423be1a0dbebc21a8f9079f3ff0027.jpg";